import React from 'react';
import './PageTableLayout.css';

/**
 * Reusable full-viewport page layout with a scrollable table and sticky header row.
 *
 * Slots:
 *   title          — page title string (rendered as h4)
 *   headerActions  — ReactNode after the title in the header bar (optional)
 *   description    — ReactNode above the filter bar (optional)
 *   filters        — ReactNode for search / filter inputs (optional)
 *   children       — <thead> + <tbody> of the table
 *   pagination     — ReactNode in the pinned bottom bar (pass null to hide)
 *   onClick        — click handler on the outer wrapper (for outside-click detection)
 *   tableClassName — extra Bootstrap/custom classes appended to the table element
 */
const PageTableLayout = ({
  title,
  headerActions,
  description,
  filters,
  children,
  pagination,
  onClick,
  tableClassName,
}) => {
  return (
    <div className="ptl-wrap" onClick={onClick}>
      <div className="ptl-header">
        <h4 className="fs_20 fw_400 fn_Roboto mx-3 mb-0">{title}</h4>
        {headerActions}
      </div>

      {(description || filters) && (
        <div className="ptl-content">
          {description}
          {filters}
        </div>
      )}

      <div className="ptl-table-wrap">
        <table className={`table ptl-table${tableClassName ? ' ' + tableClassName : ''}`}>
          {children}
        </table>
      </div>

      {pagination && (
        <div className="ptl-pagination">
          {pagination}
        </div>
      )}
    </div>
  );
};

export default PageTableLayout;
